import { render } from "./indexPublicGroup.vue?vue&type=template&id=2a75c4d0"
import script from "./indexPublicGroup.vue?vue&type=script&lang=js"
export * from "./indexPublicGroup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__